var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar shadow py-1",
    class: {
      'bg-gradient-jwa': !_vm.bgTransparent
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "flex flex-row items-center container px-4 my-2"
  }, [_c('a', {
    staticClass: "navbar-brand logo no-underline -mt-2",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("jwa.")]), _vm._v(" "), _c('svg', {
    staticClass: "fill-current h-6 w-6 ml-auto text-white mt-2 cursor-pointer md:hidden",
    attrs: {
      "viewBox": "0 0 20 20",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": _vm.toggleNavbarExpanded
    }
  }, [_c('title', [_vm._v("Menu")]), _c('path', {
    attrs: {
      "d": "M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "navbar-items hidden md:flex md:flex-grow items-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex flex-grow justify-end"
  }, [(_vm.user.guest) ? [_c('a', {
    staticClass: "btn btn-primary mx-2",
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("LOGIN")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary mx-2",
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("SIGN UP")])] : _vm._e(), _vm._v(" "), (!_vm.user.guest) ? [_c('a', {
    staticClass: "no-underline text-white flex items-center hover:text-grey-light",
    attrs: {
      "href": "/dashboard"
    }
  }, [_c('svg', {
    staticClass: "fill-current h-4 w-4 mx-2",
    attrs: {
      "viewBox": "0 0 20 20",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('title', [_vm._v("Dashboard")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm-5.6-4.29a9.95 9.95 0 0 1 11.2 0 8 8 0 1 0-11.2 0zm6.12-7.64l3.02-3.02 1.41 1.41-3.02 3.02a2 2 0 1 1-1.41-1.41z"
    }
  })]), _vm._v("\n              " + _vm._s(_vm.user.full_name) + " (#" + _vm._s(_vm.user.customer_id) + ")\n            ")])] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-items navbar-items-mobile border-t-2 border-blue px-r my-2 md:hidden",
    class: {
      hidden: !_vm.navbarExpanded
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.user.guest) ? [_vm._m(2)] : _vm._e(), _vm._v(" "), (!_vm.user.guest) ? [_c('div', {
    staticClass: "flex justify-center"
  }, [_c('a', {
    staticClass: "no-underline text-white flex items-center hover:text-blue-lightest",
    attrs: {
      "href": "/dashboard"
    }
  }, [_c('svg', {
    staticClass: "fill-current h-4 w-4 mx-2",
    attrs: {
      "viewBox": "0 0 20 20",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('title', [_vm._v("Dashboard")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm-5.6-4.29a9.95 9.95 0 0 1 11.2 0 8 8 0 1 0-11.2 0zm6.12-7.64l3.02-3.02 1.41 1.41-3.02 3.02a2 2 0 1 1-1.41-1.41z"
    }
  })]), _vm._v("\n              " + _vm._s(_vm.user.full_name) + " (#" + _vm._s(_vm.user.customer_id) + ")\n            ")])])] : _vm._e()], 2)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "pl-2"
  }, [_c('li', [_c('a', {
    staticClass: "hover:text-grey-lighter",
    attrs: {
      "href": "/#pricing"
    }
  }, [_vm._v("Pricing")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "docs"
    }
  }, [_vm._v("documentation")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/#features"
    }
  }, [_vm._v("Features")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "help"
    }
  }, [_vm._v("Help")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "px-0 text-center my-4"
  }, [_c('li', [_c('a', {
    staticClass: "hover:text-grey-lighter",
    attrs: {
      "href": "/#pricing"
    }
  }, [_vm._v("Pricing")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/docs"
    }
  }, [_vm._v("documentation")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/#features"
    }
  }, [_vm._v("Features")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/help"
    }
  }, [_vm._v("Help")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex justify-between"
  }, [_c('a', {
    staticClass: "btn btn-primary flex-grow mx-2",
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("LOGIN")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary flex-grow mx-2",
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("SIGN UP")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bc7b1de","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/navbar.vue
// module id = 484
// module chunks = 0